<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>商家</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchAll"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form
                ref="form"
                :inline="true"
                :model="form"
                class="demo-form-inline"
              >
                <div
                  v-for="(item, index) in filters"
                  :key="index"
                  class="form-filter-item"
                >
                  <el-form-item
                    v-if="item.type === 'input' && item.show"
                    :label="item.label"
                  >
                    <el-input
                      v-model="form[item.prop]"
                      style="width: 193px"
                      :placeholder="item.placeholder"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    v-if="item.type === 'date-picker' && item.show"
                    :label="item.label"
                  >
                    <el-date-picker
                      v-model="form[item.prop]"
                      :type="item.datePickerType"
                      :value-format="item.datePickerFormat"
                      :range-separator="item.datePickerRangeSeparator"
                      :start-placeholder="item.dateStartPlaceholder"
                      :end-placeholder="item.dateEndPlaceholder"
                      style="width: 313px"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item
                    v-if="item.type === 'select' && item.show"
                    :label="item.label"
                  >
                    <el-select
                      v-model="form[item.prop]"
                      :filterable="true"
                      clearable
                      :multiple="item.multiple || false"
                      :placeholder="item.placeholder"
                      @change="handleEvent(item.event, form[item.prop])"
                    >
                      <el-option
                        v-for="(option, optionIndex) in item.options"
                        :key="optionIndex"
                        :label="
                          typeof option === 'object'
                            ? option[item.labelKey || 'label']
                            : option
                        "
                        :value="
                          typeof option === 'object'
                            ? option[item.valueKey || 'value']
                            : option
                        "
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>

                <el-form-item>
                  <el-button
                    type="primary"
                    icon="el-icon-plus"
                    @click="handleSetCustomFilter"
                  ></el-button>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button @click="reset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            padding: 0 25px;
            display: flex;
            flex-direction: row-reverse;
            align-items: center;
          "
        >
          <el-button
            style="background: #85ce61; margin-left: 10px"
            type="success"
            size="mini"
            @click="output"
            >导出</el-button
          >
          <el-button type="primary" size="mini" @click="addSupply">
            +创建商家
          </el-button>
          <el-button
            type="warning"
            size="mini"
            @click="isShowBatchDialog = true"
            >+批量处理
          </el-button>

          <el-button size="mini" type="warning" @click="showImportSupplyFile">
            导入批量修改
          </el-button>
          <el-button
            size="mini"
            type="primary"
            @click="supplyControlModelVisible = true"
          >
            商家控款设置
          </el-button>
          <!-- <el-button
            style="margin-left: 10px"
            size="mini"
            type="success"
            @click="exportPlanSupplyId"
            >导出按计划点货商家</el-button
          > -->
          <!-- <el-upload
            style="margin-left: 10px"
            :action="action"
            :show-file-list="false"
            :auto-upload="true"
            :on-success="savePlanSupplyIdSuccess"
            with-credentials
          >
            <el-button slot="trigger" size="mini" type="primary">
              导入按计划点货商家
            </el-button>
          </el-upload> -->
          <el-button
            style="margin-left: 10px"
            size="mini"
            type="success"
            @click="handleExportFulfill"
            >导出商家履约信息</el-button
          >
          <el-button
            style="margin-left: 10px"
            size="mini"
            type="success"
            @click="handleExportContract"
            >导出商家合同信息</el-button
          >
          <!-- <el-button
            style="margin-left: 10px"
            size="mini"
            type="primary"
            @click="handleShowSpecialBlacklist"
            >特殊货期黑名单</el-button
          > -->
          <el-button
            style="margin-left: 10px"
            size="mini"
            type="primary"
            @click="handleCommittedSpotBlacklist"
            >承诺现货白名单</el-button
          >
          <el-button
            style="margin-left: 10px"
            size="mini"
            type="primary"
            @click="handleShowAuthWhite"
            >商家鉴权白名单</el-button
          >
          <el-button
            style="margin-left: 10px"
            size="mini"
            type="primary"
            @click="showWhiteListOperationModal"
            >专场当天报单黑名单</el-button
          >
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-plus"
            @click="handleSetTableColumn"
          ></el-button>
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            :cell-class-name="addColor"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="55"
              align="center"
              fixed="left"
            ></el-table-column>
            <div v-for="(item, index) in tableColumns" :key="index">
              <el-table-column
                v-if="item.show"
                align="center"
                :prop="item.prop"
                :label="item.label"
                :width="item.width"
              >
                <template #default="scope">
                  <!-- 判断是否鉴权增加参数 -->
                  <div>
                    <div>{{ scope.row[item.prop] }}</div>
                    <div
                      v-if="
                        item.prop === 'is_authentication' &&
                        scope.row.sub_acct_no
                      "
                      style="color: blue; margin-top: 8px"
                    >
                      商家子账户：
                      <div>{{ scope.row.sub_acct_no }}</div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </div>
            <el-table-column
              label="操作"
              align="center"
              fixed="right"
              width="100"
            >
              <template #default="scope">
                <el-button size="mini" type="text" @click="profile(scope.row)">
                  用户画像
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="updateSupply(scope.row)"
                  >修改商家</el-button
                >
                <el-button
                  size="mini"
                  type="text"
                  @click="showSupply(scope.row)"
                  >查看</el-button
                >
                <el-button
                  size="mini"
                  type="text"
                  @click="supplyLog(scope.row)"
                >
                  查看日志</el-button
                >
                <el-button
                  v-if="scope.row.sub_acct_no"
                  size="mini"
                  type="text"
                  @click="closeAcctInfo(scope.row)"
                  >子账户销户</el-button
                >
                <el-button
                  v-if="scope.row.is_bind_bank_bool === 1"
                  size="mini"
                  type="text"
                  @click="handleAuthAccount(scope.row)"
                  >提现绑卡鉴权</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-dialog title="操作日志" :visible.sync="logVisible" width="70%">
            <div v-if="logData">
              <el-table :data="logData.list">
                <el-table-column
                  property="action_value"
                  label="事件"
                  align="center"
                ></el-table-column>
                <el-table-column
                  property="action_content"
                  label="内容"
                  align="center"
                  width="400px"
                >
                  <template #default="scope">
                    <div v-html="scope.row.action_content">
                      {{ scope.row.action_content }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  property="operator_name"
                  label="操作人"
                  align="center"
                ></el-table-column>
                <el-table-column
                  property="action_remark"
                  label="备注"
                  align="center"
                >
                  <template #default="scope">
                    <div class="remark-wrap">
                      <div class="remark">{{ scope.row.action_remark }}</div>
                      <div class="file">
                        <el-button
                          type="text"
                          @click="handleDownloadFile(scope.row.file_url)"
                          >{{ scope.row.file_name }}</el-button
                        >
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  property="create_date"
                  label="操作时间"
                  align="center"
                >
                </el-table-column>
              </el-table>
              <div style="text-align: right; padding: 25px">
                <el-pagination
                  :current-page.sync="logcurPage"
                  background
                  layout="total, prev, pager, next, jumper "
                  :total="logData.logpages"
                  :page-size="10"
                  @current-change="handleCurrentChange2"
                ></el-pagination>
              </div>
            </div>
          </el-dialog>
        </div>
        <div v-if="showBind">
          <PgBindSupply :supply-ids="supply_ids" @onCloseDialog="closeBox" />
        </div>
        <div v-if="showBindBuyer">
          <BuyerBindSupply
            visible-type="showBindBuyer"
            :supply-ids="supply_ids"
            @onCloseDialog="closeBox"
          />
        </div>
        <div v-if="showBindMarket">
          <MarketBindSupply
            visible-type="showBindMarket"
            :supply-ids="supply_ids"
            @onCloseDialog="closeBox"
          />
        </div>
        <div v-if="showChangeAcct">
          <ChangeAcctInfo :supply-id="supply_id" @onCloseDialog="closeBox" />
        </div>
        <div v-if="showDgBind" class="show-dg-bind">
          <DgBindSupply
            :supply-ids="supply_ids"
            :group="defectiveGroupOption"
            @on-close-dialog="closeDgBox"
          />
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper, sizes "
            :total="resData.pages"
            :page-size="10"
            :page-sizes="[10, 50, 100, 200]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <import-supply-file-dialog
      :show="importSupplyFileVisible"
      @close="closeImportSupplyFile"
    />
    <!-- 自定义搜索过滤选项 -->
    <el-dialog
      width="797px"
      title="自定义选项框"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="customFilterVisible"
      append-to-body
    >
      <div class="filter-box">
        <div class="custom-list">
          <span
            v-for="(item, index) in customFilters"
            :key="index"
            class="custom-item"
            :class="{ 'custom-item--active': item.active }"
            @click="handleToggleFilter(item)"
            >{{ item.label }}</span
          >
        </div>
      </div>
    </el-dialog>
    <!-- 自定义表格列 columns -->
    <el-dialog
      width="797px"
      title="自定义表头"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="customTableColumnVisible"
      append-to-body
    >
      <div class="filter-box">
        <div class="custom-list">
          <span
            v-for="(item, index) in customTableColumns"
            :key="index"
            class="custom-item"
            :class="{ 'custom-item--active': item.active }"
            @click="handleToggleTableColumn(item)"
            >{{ item.label }}</span
          >
        </div>
      </div>
    </el-dialog>
    <!-- 批量处理  -->
    <el-dialog
      width="260px"
      title="批量处理"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="isShowBatchDialog"
      append-to-body
      @close="handleDialogButtonClose"
    >
      <div class="filter-box-btns">
        <el-button
          type="warning"
          style="margin: 4px"
          @click="showDgBind = true"
        >
          批量绑定「次品员与退供员」
        </el-button>
        <el-button type="warning" style="margin: 4px" @click="showBind = true">
          批量绑定「代采组与代采员」
        </el-button>
        <el-button
          type="warning"
          style="margin: 4px"
          @click="handleBindFollower"
        >
          批量绑定「前置仓跟进人」
        </el-button>
        <el-button
          type="warning"
          style="margin: 4px"
          @click="handleBindBusinessOperatorFollower"
        >
          批量绑定「商家运营跟进人」
        </el-button>
        <el-button
          type="warning"
          style="margin: 4px"
          @click="isShowBatchChangeStatusDialog = true"
        >
          批量修改「商家状态」
        </el-button>
        <el-button
          type="warning"
          style="margin: 4px"
          @click="isShowInvitationPoolDialog = true"
        >
          批量修改「邀约池配置」
        </el-button>
        <el-button
          type="warning"
          style="margin: 4px"
          @click="isShowPerformanceMarketDialog = true"
        >
          批量修改「业绩归属市场」
        </el-button>
        <el-button
          type="warning"
          style="margin: 4px"
          @click="isShowSpecialSaleDialog = true"
        >
          能否参与特价销售
        </el-button>
        <el-button
          type="warning"
          style="margin: 4px"
          @click="isShowReturnAddressDialog = true"
        >
          退换货收货地址修改
        </el-button>
        <el-button
          type="warning"
          style="margin: 4px"
          @click="handleShowAddressDialog"
        >
          无数据地址修改
        </el-button>
        <el-button
          type="warning"
          style="margin: 4px"
          @click="isShowSupplyPermissionDialog = true"
        >
          批量修改「商家权限」
        </el-button>
        <el-button
          type="warning"
          style="margin: 4px"
          @click="showBindBuyer = true"
        >
          批量改「买手组与买手」
        </el-button>
        <el-button
          type="warning"
          style="margin: 4px"
          @click="showBindMarket = true"
        >
          批量改「市场与子市场」
        </el-button>
      </div>
    </el-dialog>
    <!-- 批量绑定前置仓跟进人 -->
    <el-dialog
      align="center"
      width="640px"
      title="批量绑定「前置仓跟进人」"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="isShowBatchBindFollowerDialog"
      append-to-body
      @close="handleBatchBindFollowerClose"
    >
      <el-form
        ref="batchFollowerFormRef"
        :model="batchFollowerForm"
        :inline="false"
        size="normal"
      >
        <el-row :gutter="24">
          <el-col :span="10">
            <el-form-item
              label="商家id（一行一个，最多1000个）"
              required
              label-position="top"
            >
              <!-- <div style="margin-bottom: 16px">
              <span></span>
            </div> -->
              <el-input
                v-model="batchFollowerForm.supply_ids"
                :rows="8"
                type="textarea"
                placeholder="一行一个id"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14" :style="{ marginTop: '40px' }">
            <el-form-item label="前置仓跟进人" align="left">
              <el-select
                v-model="batchFollowerForm.pre_storage_admin"
                placeholder="请选择"
                filterable
                clearable
              >
                <el-option
                  v-for="item in followerList"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer">
        <el-button @click="isShowBatchBindFollowerDialog = false"
          >取消</el-button
        >
        <el-button type="primary" @click="handleBatchBindFollower">
          确定
        </el-button>
      </div>
    </el-dialog>
    <!-- 批量绑定商家运营仓跟进人 -->
    <el-dialog
      align="center"
      width="640px"
      title="批量绑定「商家运营仓跟进人」"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="isShowBusinessOperatorDialog"
      append-to-body
      @close="handleBatchBindBusinessOperatorFollowerClose"
    >
      <el-form
        ref="batchBusinessOperatorFollowerFormRef"
        :model="batchBusinessOperatorFollowerForm"
        :inline="false"
        size="normal"
      >
        <el-row :gutter="24">
          <el-col :span="10">
            <el-form-item
              label="商家id（一行一个，最多1000个）"
              required
              label-position="top"
            >
              <el-input
                v-model="batchBusinessOperatorFollowerForm.supply_ids"
                :rows="8"
                type="textarea"
                placeholder="一行一个id"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14" :style="{ marginTop: '40px' }">
            <el-form-item label="商家运营跟进人" align="left">
              <el-select
                v-model="batchBusinessOperatorFollowerForm.follower_admin_id"
                placeholder="请选择"
                filterable
                clearable
              >
                <el-option
                  v-for="item in businessOperatorFollowerList"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer">
        <el-button @click="isShowBusinessOperatorDialog = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="handleBatchBindBusinessOperatorFollower"
        >
          确定
        </el-button>
      </div>
    </el-dialog>
    <!-- 批量修改商家状态 -->
    <el-dialog
      width="640px"
      title="批量处理"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="isShowBatchChangeStatusDialog"
      append-to-body
      @close="handleBatchChangeStatusClose"
    >
      <el-form
        ref="batchUpdateSupplyFormRef"
        :model="batchUpdateSupplyForm"
        :rules="batchUpdateSupplyFormRules"
        label-width="80px"
        :inline="false"
        size="normal"
        label-position="top"
      >
        <el-row :gutter="24">
          <el-col :span="10">
            <div style="margin-bottom: 16px">
              <span>商家id（一行一个，最多1000个）</span>
            </div>
            <el-input
              v-model="batchUpdateSupplyForm.supply_ids"
              :rows="8"
              type="textarea"
              placeholder="一行一个id"
            ></el-input>
          </el-col>
          <el-col :span="14">
            <div style="display: flex">
              <span>商家状态：</span>
              <el-select v-model="batchUpdateSupplyForm.status">
                <el-option
                  v-for="item in constantMap.optionSupplyStatus"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </div>
            <div>
              <el-form-item
                label="请填写备注（必填）"
                size="normal"
                prop="remark"
              >
                <el-input
                  v-model="batchUpdateSupplyForm.remark"
                  type="textarea"
                  placeholder="属于审计监控内容，请如实填报！"
                  :rows="6"
                  maxlength="200"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer">
        <!-- <el-button @click="isShowBatchChangeStatusDialog = false"
          >取消</el-button
        > -->
        <el-button type="primary" @click="handleBatchChangeStatus">
          确定
        </el-button>
      </div>
    </el-dialog>
    <!-- 商家鉴权白名单 -->
    <auth-white-dialog ref="authWhiteRef" />
    <!-- 特殊货期黑名单 -->
    <special-blacklist-dialog ref="specialBlacklistDialogRef" />
    <!-- 承诺库存黑名单 -->
    <committed-spot-blacklist-dialog ref="committedSpotBlacklistDialogRef" />
    <el-dialog
      :visible.sync="isShowInvitationPoolDialog"
      title="批量修改邀约池配置"
      width="30%"
      append-to-body
      :close-on-click-modal="false"
      @close="handleInvitationDialogClose"
    >
      <div>1、被导入的商家会被替换新规则</div>
      <div>2、模版可以用导出功能获取</div>
      <el-row
        type="flex"
        :gutter="8"
        wrap
        style="margin-top: 12px"
        justify="space-between"
      >
        <el-upload
          ref="invitationUpload"
          :action="actionInvitation"
          :limit="1"
          :on-success="handleImportSuccess"
          :show-file-list="false"
          name="file"
          auto-upload
          with-credentials
        >
          <el-button type="primary">导入商家邀约规则配置</el-button>
        </el-upload>
        <el-button type="success" @click="handleExportInvitationRule">
          导出商家邀约规则配置
        </el-button>
      </el-row>
    </el-dialog>
    <!-- 选择鉴权弹窗  -->
    <el-dialog
      :visible.sync="isShowChooseAuthDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      title="提现绑卡鉴权"
      @close="handleAuthTypeDialogClose"
    >
      <el-form ref="formAcctType" :model="formAcctType">
        <el-form-item
          label="选择绑定的账户类型"
          prop="type"
          :rules="rules.ruleChange"
        >
          <el-radio-group v-model="formAcctType.type">
            <el-radio
              v-for="option in constantMap.optionsAcctType"
              :key="option.value"
              :label="option.value"
            >
              {{ option.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="isShowChooseAuthDialog = false">取消</el-button>
        <el-button type="primary" @click="handleConfirmAuthType">
          确定
        </el-button>
      </template>
    </el-dialog>
    <!-- 个人鉴权弹窗  -->
    <el-dialog
      :visible.sync="isShowPersonAuthDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      title="提现绑卡鉴权"
      @close="handleAuthDialogClose"
    >
      <el-form
        ref="formAcct"
        key="personal"
        :model="formAcct"
        label-width="100px"
        size="small"
      >
        <el-form-item
          label="姓名"
          prop="corporate_name"
          :rules="rules.ruleBlur"
        >
          <ys-input
            v-model="formAcct.corporate_name"
            :disabled="
              !!(
                isHasSubAcct && acctBindData.supply_sub_acct_info.corporate_name
              )
            "
            style="width: 40%; margin-right: 12px"
          ></ys-input>
          <span
            v-if="
              acctBindData.is_sub_acct !== constantMap.isHasSubAcct ||
              acctBindData.sub_acct_type === constantMap.isNoRealName
            "
            style="color: gray"
          >
            如需更换绑卡人，请先注销子账户
          </span>
        </el-form-item>
        <el-form-item label="证件" prop="id_number" :rules="rules.ruleBlur">
          <el-select
            v-model="formAcct.id_type"
            :disabled="
              !!(
                isHasSubAcct &&
                !['', '0'].includes(acctBindData.supply_sub_acct_info.id_type)
              )
            "
          >
            <el-option
              v-for="item in constantMap.optionsIdType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <ys-input
            v-model="formAcct.id_number"
            :disabled="
              !!(isHasSubAcct && acctBindData.supply_sub_acct_info.id_number)
            "
            style="width: 50%"
          ></ys-input>
        </el-form-item>
        <el-form-item label="账户类型"> {{ acctTypeName }} </el-form-item>
        <el-form-item
          label="开户银行"
          prop="payee_bank"
          :rules="rules.ruleChange"
        >
          <el-select
            v-model="formAcct.payee_bank"
            :popper-append-to-body="true"
            filterable
            style="width: 60%"
          >
            <el-option
              v-for="item in optionsMap.bankList"
              :key="item.key"
              :label="item.label"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="银行账号"
          prop="payee_bank_account"
          :rules="rules.ruleBlur"
        >
          <ys-input
            v-model.trim="formAcct.payee_bank_account"
            pattern="positiveInt"
            style="width: 60%"
          ></ys-input>
          <el-checkbox
            v-model="formAcct.is_default"
            true-label="1"
            false-label="2"
            style="margin-left: 8px"
          >
            设为默认账号
          </el-checkbox>
        </el-form-item>
        <el-form-item
          label="手机号码"
          prop="payee_phone"
          :rules="rules.ruleBlur"
        >
          <ys-input
            v-model="formAcct.payee_phone"
            :disabled="
              !!(
                (isHasSubAcct &&
                  acctBindData.supply_sub_acct_info.payee_phone) ||
                acctBindData.supply_sub_acct_info.bind_sub_acct_phone
              )
            "
            pattern="positiveInt"
            :maxlength="11"
            style="width: 60%"
          ></ys-input>
        </el-form-item>
        <el-form-item
          label="短信验证码"
          prop="check_code"
          :rules="rules.ruleBlur"
        >
          <ys-input v-model="formAcct.check_code" style="width: 60%"></ys-input>
          <el-button
            :disabled="count !== constantMap.timeCount"
            type="primary"
            size="small"
            style="margin-left: 8px; width: 100px"
            @click="handleSendSms"
          >
            {{ count === constantMap.timeCount ? "发送验证码" : `${count}s` }}
          </el-button>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button
          :loading="loadingAcct"
          @click="isShowPersonAuthDialog = false"
        >
          取消
        </el-button>
        <el-button
          :loading="loadingAcct"
          type="primary"
          @click="handleConfirmAuthAcct"
        >
          确定
        </el-button>
      </template>
    </el-dialog>
    <!-- 对公鉴权弹窗  -->
    <el-dialog
      :visible.sync="isShowAuthDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      title="提现绑卡鉴权"
      @close="handleAuthDialogClose"
    >
      <el-steps
        :active="activeStep"
        simple
        finish-status="success"
        style="margin-bottom: 12px"
      >
        <el-step title="1、填写信息，提交绑卡申请"></el-step>
        <el-step title="2、回填打款金额与鉴权序号"></el-step>
      </el-steps>
      <template v-if="activeStep === 0">
        <el-form
          ref="formAcct"
          key="individual"
          :model="formAcct"
          label-width="100px"
          size="small"
        >
          <el-form-item
            label="企业名称"
            prop="company_name"
            :rules="rules.ruleBlur"
          >
            <ys-input
              v-model="formAcct.company_name"
              :disabled="
                !!(
                  isHasSubAcct && acctBindData.supply_sub_acct_info.company_name
                )
              "
            ></ys-input>
          </el-form-item>
          <el-form-item
            label="统一社会信用代码"
            prop="credit_code"
            :rules="rules.ruleBlur"
          >
            <ys-input
              v-model="formAcct.credit_code"
              :disabled="
                !!(
                  isHasSubAcct && acctBindData.supply_sub_acct_info.credit_code
                )
              "
            ></ys-input>
          </el-form-item>
          <el-form-item
            label="法人姓名"
            prop="corporate_name"
            :rules="rules.ruleBlur"
          >
            <ys-input
              v-model="formAcct.corporate_name"
              :disabled="
                !!(
                  isHasSubAcct &&
                  acctBindData.supply_sub_acct_info.corporate_name
                )
              "
              style="width: 40%"
            ></ys-input>
            <span
              v-if="
                acctBindData.is_sub_acct !== constantMap.isHasSubAcct ||
                acctBindData.sub_acct_type === constantMap.isNoRealName
              "
              style="color: gray"
            >
              如需更换绑卡人，请先注销子账户
            </span>
          </el-form-item>
          <el-form-item
            label="法人证件"
            prop="id_number"
            :rules="rules.ruleBlur"
          >
            <el-select
              v-model="formAcct.id_type"
              :disabled="
                formAcct.bind_sub_acct_type === constantMap.individualAcct ||
                !!(
                  isHasSubAcct &&
                  !['', '0'].includes(acctBindData.supply_sub_acct_info.id_type)
                )
              "
              style="width: 50%"
            >
              <el-option
                v-for="item in constantMap.optionsIdTypePublic"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <ys-input
              v-model="formAcct.id_number"
              :disabled="
                !!(isHasSubAcct && acctBindData.supply_sub_acct_info.id_number)
              "
              style="width: 50%"
            ></ys-input>
          </el-form-item>
          <el-form-item label="账户类型"> {{ acctTypeName }} </el-form-item>
          <el-form-item
            label="开户银行"
            prop="payee_bank"
            :rules="rules.ruleChange"
          >
            <el-select
              v-model="formAcct.payee_bank"
              :popper-append-to-body="true"
              filterable
              style="width: 60%"
            >
              <el-option
                v-for="item in optionsMap.bankList"
                :key="item.key"
                :label="item.key"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="银行账号"
            prop="payee_bank_account"
            :rules="rules.ruleBlur"
          >
            <ys-input
              v-model="formAcct.payee_bank_account"
              pattern="positiveInt"
              style="width: 60%"
            ></ys-input>
            <el-checkbox
              v-model="formAcct.is_default"
              true-label="1"
              false-label="2"
              style="margin-left: 8px"
            >
              设为默认账号
            </el-checkbox>
          </el-form-item>
          <el-form-item
            label="手机号码"
            prop="payee_phone"
            :rules="rules.ruleBlur"
          >
            <ys-input
              v-model="formAcct.payee_phone"
              :disabled="
                !!(
                  isHasSubAcct &&
                  (acctBindData.supply_sub_acct_info.payee_phone ||
                    acctBindData.supply_sub_acct_info.bind_sub_acct_phone)
                )
              "
              pattern="positiveInt"
              :maxlength="11"
              style="width: 60%"
            ></ys-input>
          </el-form-item>
        </el-form>
      </template>
      <template v-else>
        <el-form
          ref="formAcct"
          key="business"
          :model="formAcct"
          label-width="100px"
          size="small"
        >
          <el-form-item label="企业名称">
            {{ formAcct.company_name }}
            <span style="color: gray">
              （统一社会信用代码：{{ formAcct.credit_code }}）
            </span>
          </el-form-item>
          <el-form-item label="法人">
            {{ formAcct.corporate_name }}
            <span style="color: gray">
              （{{ idTypeName }}：{{ formAcct.id_number }}）
            </span>
          </el-form-item>
          <el-form-item label="账户类型"> {{ acctTypeName }} </el-form-item>
          <el-form-item label="银行账号">
            {{ formAcct.payee_bank_account }}
            <span style="color: gray"> （{{ formAcct.payee_bank }}） </span>
            <el-checkbox
              v-model="formAcct.is_default"
              true-label="1"
              false-label="2"
              style="margin-left: 8px"
            >
              设为默认账号
            </el-checkbox>
          </el-form-item>
          <el-form-item label="手机号码">
            {{ formAcct.payee_phone }}
            <el-button
              :disabled="count !== constantMap.timeCount"
              type="primary"
              size="small"
              style="margin-left: 8px; width: 100px"
              @click="handleResendSms"
            >
              {{
                count === constantMap.timeCount ? "重发鉴权序号" : `${count}s`
              }}
            </el-button>
            <el-button
              type="danger"
              size="small"
              style="margin-left: 8px; width: 100px"
              @click="handleAcctApplyCancel"
            >
              取消申请
            </el-button>
          </el-form-item>
          <el-form-item label="打款状态">
            <span>{{ formAcct.application_return_status_text }}</span>
            <span
              v-if="formAcct.return_status === constantMap.returnStatus.failed"
              style="color: #fb0825; padding-left: 12px"
            >
              {{ formAcct.return_msg }}
            </span>
          </el-form-item>
          <el-form-item
            label="打款金额"
            prop="auth_amt"
            :rules="rules.ruleBlur"
          >
            <ys-input
              v-model="formAcct.auth_amt"
              pattern="money"
              style="width: 40%"
            >
              <template #append>元</template>
            </ys-input>
            <div style="color: gray">
              已于{{ formAcct.created_at }}
              给上述银行账户提交一笔金额在0.01-0.50的打款申请，请在银行查看收支明细，回填打款金额，超48小时将失效。24小时内不可重复申请。
            </div>
          </el-form-item>
          <el-form-item
            label="鉴权序号"
            prop="order_no"
            :rules="rules.ruleBlur"
          >
            <ys-input v-model="formAcct.order_no" style="width: 60%"></ys-input>
            <div style="color: gray; margin-left: 12px">
              请查看短信，鉴权序号48小时内有效，24小时内可重发
            </div>
          </el-form-item>
        </el-form>
      </template>
      <template #footer>
        <template v-if="activeStep === 0">
          <el-button :loading="loadingAcct" @click="isShowAuthDialog = false">
            取消
          </el-button>
          <el-button
            :loading="loadingAcct"
            type="primary"
            @click="handleConfirmAuthAcctApply"
          >
            提交申请
          </el-button>
        </template>
        <template v-if="activeStep === 1">
          <el-button :loading="loadingAcct" @click="isShowAuthDialog = false">
            关闭
          </el-button>
          <el-button
            :loading="loadingAcct"
            type="primary"
            @click="handleConfirmAuthAcct"
          >
            确定
          </el-button>
        </template>
      </template>
    </el-dialog>
    <el-dialog
      width="500px"
      :visible.sync="specialEventOrderWhitelistModalVisible"
    >
      <p>1、名单中的商家专场不生成当天报单计划，爆版不展示"今日实时订单池</p>
      <p>2、导入后替换原来的商家名单</p>
      <p>3、导入的格式为：从A2~A无限，一个单元格一个商家ID</p>
      <span slot="footer" class="dialog-footer">
        <el-upload
          style="display: inline; margin-right: 10px"
          :action="importBlackDayReportAction"
          :show-file-list="false"
          :auto-upload="true"
          name="excel"
          :on-success="importWhiteList"
          :on-progress="showLoadingOnProgress"
          with-credentials
        >
          <el-button type="primary" :loading="loadingOnProgress">
            导入黑名单</el-button
          >
        </el-upload>
        <el-button type="success" @click="onExportBlackDayReport">
          导出黑名单</el-button
        >
      </span>
    </el-dialog>
    <!-- 批量修改业绩归属市场 -->
    <el-dialog
      width="640px"
      title="批量处理"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="isShowPerformanceMarketDialog"
      append-to-body
      @close="handleBatchPerformanceMarketClose"
    >
      <el-form
        ref="batchUpdatePerformanceMarketFormRef"
        :model="batchUpdatePerformanceMarketForm"
        :rules="batchUpdatePerformanceMarketFormRules"
        label-width="80px"
        :inline="false"
        size="normal"
        label-position="top"
      >
        <el-row :gutter="24">
          <el-col :span="10">
            <div style="margin-bottom: 16px">
              <span>商家id（一行一个，最多1000个）</span>
            </div>
            <el-input
              v-model="batchUpdatePerformanceMarketForm.supply_id"
              :rows="8"
              type="textarea"
              placeholder="一行一个id"
            ></el-input>
          </el-col>
          <el-col :span="14">
            <div style="display: flex">
              <span style="width: 130px; text-align: right"
                >业绩归属市场：</span
              >
              <el-select
                v-model="
                  batchUpdatePerformanceMarketForm.attributable_market_id
                "
                @change="
                  handleSetAttributableSubMarket(
                    batchUpdatePerformanceMarketForm.attributable_market_id
                  )
                "
              >
                <el-option
                  v-for="item in performanceMarketOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div style="display: flex; margin-top: 20px">
              <span style="width: 130px; text-align: right"
                >业绩归属细分市场：</span
              >
              <el-select
                v-model="
                  batchUpdatePerformanceMarketForm.attributable_market_sub_id
                "
              >
                <el-option
                  v-for="item in performanceSubMarketOptions"
                  :key="item.sub_id"
                  :label="item.sub_name"
                  :value="item.sub_id"
                >
                </el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer">
        <!-- <el-button @click="isShowPerformanceMarketDialog = false"
                >取消</el-button
              > -->
        <el-button type="primary" @click="handleBatchPerformanceMarket">
          确定
        </el-button>
      </div>
    </el-dialog>
    <!-- 能否参与特价销售 -->
    <el-dialog
      align="center"
      width="640px"
      title="批量修改「能否参与特价销售」"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="isShowSpecialSaleDialog"
      append-to-body
      @close="handleBatchSpecialSaleClose"
    >
      <el-form
        ref="batchSpecialSaleFormRef"
        :model="batchSpecialSaleForm"
        :inline="false"
        size="normal"
        label-position="top"
      >
        <el-row :gutter="24">
          <el-col :span="10">
            <el-form-item label="商家id（一行一个，最多1000个）" required>
              <el-input
                v-model="batchSpecialSaleForm.supply_ids"
                :rows="8"
                type="textarea"
                placeholder="一行一个id"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14" :style="{ marginTop: '40px' }">
            <el-form-item label="能否参与特价销售" align="left">
              <el-select
                v-model="batchSpecialSaleForm.special_sale"
                placeholder="请选择"
                filterable
                clearable
              >
                <el-option value="1" label="是"></el-option>
                <el-option value="2" label="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否特价治理" align="left">
              <el-select
                v-model="batchSpecialSaleForm.is_special_treatment"
                placeholder="请选择"
                filterable
                clearable
              >
                <el-option value="1" label="是"></el-option>
                <el-option value="2" label="否"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer">
        <el-button @click="isShowSpecialSaleDialog = false">取消</el-button>
        <el-button type="primary" @click="handleBatchSpecialSale">
          确定
        </el-button>
      </div>
    </el-dialog>
    <!-- 新增 批量修改无数据寄回地址弹框 -->
    <el-dialog
      title="批量修改无数据寄回地址"
      :visible.sync="addressDialogVisible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <div>
        <div class="address-item">
          <div class="label">批量导入修改信息</div>
          <el-upload
            :action="uploadUrl"
            name="excel"
            :show-file-list="false"
            :before-upload="beforeUpload"
            :on-success="handleUploadSuccess"
            with-credentials
          >
            <el-button size="small" type="primary">单击上传</el-button>
          </el-upload>
        </div>

        <div class="address-item">
          <el-button size="small" type="primary" @click="handleDownloadTemplate"
            >下载模板</el-button
          >
          <div class="desc">每次导入5000条</div>
        </div>
      </div>

      <div slot="footer">
        <el-button type="primary" @click="handleConfirmAddress">确定</el-button>
      </div>
    </el-dialog>
    <!-- 批量修改商家权限 -->
    <el-dialog
      width="640px"
      title="批量修改「商家权限」"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="isShowSupplyPermissionDialog"
      append-to-body
      @close="handleBatchSupplyPermissionClose"
    >
      <el-form
        ref="supplyPermissionFormRef"
        :model="supplyPermissionForm"
        :inline="false"
        size="normal"
        label-position="top"
      >
        <el-row :gutter="24">
          <el-col :span="10">
            <el-form-item label="商家id（一行一个，最多1000个）" required>
              <el-input
                v-model="supplyPermissionForm.supply_ids"
                :rows="8"
                type="textarea"
                placeholder="一行一个id"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14" :style="{ marginTop: '40px' }">
            <el-form-item label="是否自主上款">
              <el-select
                v-model="supplyPermissionForm.is_self"
                placeholder="请选择"
                filterable
                clearable
              >
                <el-option value="1" label="是"></el-option>
                <el-option value="0" label="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="自主上款全类目">
              <el-select
                v-model="supplyPermissionForm.is_all_style"
                placeholder="请选择"
                filterable
                clearable
              >
                <el-option value="1" label="是"></el-option>
                <el-option value="0" label="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开通爆版开单">
              <el-select
                v-model="supplyPermissionForm.is_order_ability"
                placeholder="请选择"
                filterable
                clearable
              >
                <el-option value="1" label="是"></el-option>
                <el-option value="0" label="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="请填写备注" required>
              <el-input
                v-model="supplyPermissionForm.remark"
                placeholder="属于审计监控内容，请如实填报！"
                clearable
                type="textarea"
                show-word-limit
                maxlength="200"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <template #footer>
        <el-button @click="isShowSupplyPermissionDialog = false"
          >取消</el-button
        >
        <el-button type="primary" @click="handleBatchSupplyPermission">
          确定
        </el-button>
      </template>
    </el-dialog>
    <!-- 批量修改商家权限提示 -->
    <el-dialog
      title="操作提示"
      :visible.sync="isShowSupplyPermissionResultDialog"
      append-to-body
    >
      <div v-for="item in resultData.success" :key="item">
        <span style="color: #85ce61">{{ item }}-success</span>
      </div>
      <div v-for="item in resultData.error" :key="item">
        <span style="color: red">{{ item }}-操作失败</span>
      </div>
      <template #footer>
        <el-button @click="isShowSupplyPermissionResultDialog = false"
          >关闭窗口</el-button
        >
      </template>
    </el-dialog>
    <!-- 商家控款设置 -->
    <supply-control-model-dialog
      :show="supplyControlModelVisible"
      @close="supplyControlModelVisible = false"
    />
    <!-- 添加退换货地址弹窗 -->
    <import-return-address-dialog
      :show="isShowReturnAddressDialog"
      @close="handleCloseReturnAddressDialog"
    />
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";
import { isNil, omitBy } from "lodash-es";

import {
  batchUpdateSupplyPreStorageAdmin,
  getAllEnableAdmin,
} from "@/controller/supply2267.js";
import {
  getExportAutoStockPlan,
  getGetAttributableMarketList,
  getOptionsForSupplyList,
  postBatchBindAttributableMarket,
  postBatchEditLimitsAuthority,
  postBatchUpdateFollowerAdmin,
  postBatchUpdateSpecialSaleStatus,
  postExportBlackDayReport,
  postGetAllEnableAdmin,
} from "@/openapi/erp/supply.js";
import { isSignedContractSupply, supplySettleDays } from "@/tool/const.js";
import { Local } from "@/utils/utils.js";
import DgBindSupply from "../DgBindSupply.vue";
import BuyerBindSupply from "./components/BuyerBindSupply.vue";
import ChangeAcctInfo from "./components/ChangeAcctInfo.vue";
import ImportSupplyFileDialog from "./components/ImportSupplyFileDialog.vue";
import MarketBindSupply from "./components/MarketBindSupply.vue";
import PgBindSupply from "./components/PgBindSupply.vue";

import { downloadSupplyFulfill } from "@/api/supply.js";
import {
  batchUpdateSupply,
  exportSupplyContract,
} from "@/controller/supply.js";
import {
  customFilters,
  customTableColumns,
  filters,
  tableColumns,
} from "./supply-list.js";

import rules from "@/const/rules.js";
import * as commonApi from "@/controller/common2302.js";
import * as invitationPoolApi from "@/controller/invitationPool3350.js";
import * as supplyApi from "@/controller/supply2267.js";
import { openDownloadWindow } from "@/utils/export.js";
import AuthWhiteDialog from "./components/AuthWhiteDialog.vue";
import CommittedSpotBlacklistDialog from "./components/CommittedSpotBlacklistDialog.vue";
import ImportReturnAddressDialog from "./components/ImportReturnAddressDialog.vue";
import SpecialBlacklistDialog from "./components/SpecialBlacklistDialog.vue";
import SupplyControlModelDialog from "./components/SupplyControlModelDialog.vue";

const constantMap = Object.freeze({
  optionsAcctType: [
    { label: "个人银行卡", value: "1" },
    { label: "个体工商户对公账户", value: "2" },
    { label: "企业对公账户", value: "3" },
  ],
  optionsIdType: [
    { label: "身份证", value: "1" },
    { label: "回乡证（港澳台居民通行证）", value: "3" },
    { label: "中国护照", value: "4" },
    { label: "台胞证(台湾居民来往大陆通行证)", value: "5" },
    { label: "外国护照", value: "19" },
  ],
  optionsIdTypePublic: [
    { label: "身份证", value: "1" },
    { label: "回乡证（港澳台居民通行证）", value: "3" },
    { label: "台胞证(台湾居民来往大陆通行证)", value: "5" },
    { label: "外国护照", value: "19" },
  ],
  optionSupplyStatus: [
    { label: "启用", value: "1", confirmText: "确认启用以上商家？" },
    {
      label: "禁用",
      value: "2",
      confirmText:
        "禁用后，该档口自动解绑爆版账号，且该档口的商品库全部自动下架并断货",
    },
    {
      label: "待禁用",
      value: "3",
      confirmText: "待禁用后，该档口的商品库全部自动下架并断货，并且无法上款",
    },
  ],
  personalAcct: "1",
  individualAcct: "2",
  businessAcct: "3",
  timeCount: 120,
  // 绑定个人账户
  personalBindType: "1",
  // 绑定个体工商户对公账户
  individualBindType: "2",
  // 绑定企业对公账户
  businessBindType: "3",
  // 正在申请
  isApplying: 1,
  isCompany: "3",
  // 有子账户
  isHasSubAcct: 1,
  personalSubAcct: "3",
  businessSubAcct: "4",
  // 身份证
  idCard: "1",
  // 非实名子账户
  isNoRealName: "1",
  returnStatus: {
    failed: "4",
  },
});
export default {
  components: {
    ImportSupplyFileDialog,
    PgBindSupply,
    BuyerBindSupply,
    MarketBindSupply,
    ChangeAcctInfo,
    DgBindSupply,
    AuthWhiteDialog,
    SpecialBlacklistDialog,
    CommittedSpotBlacklistDialog,
    SupplyControlModelDialog,
    ImportReturnAddressDialog,
  },
  data() {
    const companyName = this.$route.params.company_name || "";
    return {
      constantMap,
      rules,
      customFilterVisible: false,
      customTableColumnVisible: false,
      customFilters, // 自定义过滤项
      customTableColumns, // 自定义表格列
      filters, // 过滤项
      tableColumns, // 表格列
      logpages: 0,
      logcurPage: 1,
      supplySettleDays,
      isSignedContractSupply,
      supply_ids: [],
      showBind: false,
      logData: [],
      logVisible: false,
      resData: null,
      supply: {
        list: [],
      },
      form: {
        status: "",
        create_time: [],
        supply_id: "",
        set_pgid: "", // 设置的代采组id
        market_id: [],
        father_market_id: [],
        company_name: companyName,
        is_order_ability: "",
        is_all_style: "",
        is_benchmarking: "",
      },
      loading: false,
      tableLoading: false,
      url: "/erp/Supply/SupplyList",
      curPage: 1,
      filterFold: false,
      isAll: false,
      supplyData: null,
      dialogFormVisible: false,
      cur_id: 0,
      supply_id: 0,
      showDgBind: false,
      showChangeAcct: false,
      importSupplyFileVisible: false,
      marketOptions: [],
      defectiveGroupOption: [], // 次品组 option
      selectionList: [], // 记录勾选项
      isShowBatchDialog: false,
      isShowBatchChangeStatusDialog: false,
      isShowBatchBindFollowerDialog: false,
      isShowInvitationPoolDialog: false,
      isShowPerformanceMarketDialog: false,
      isShowSpecialSaleDialog: false,
      isShowReturnAddressDialog: false,
      isShowSupplyPermissionDialog: false,
      isShowSupplyPermissionResultDialog: false,
      followerList: [],
      businessOperatorFollowerList: [], // 商家运营跟进人
      batchUpdateSupplyForm: {
        supply_ids: "",
        remark: "",
        status: "",
      },
      // action: `${apiBaseURL}/erp/Supply/importExcelToSavePlanSupply`,
      batchUpdateSupplyFormRules: {
        remark: [
          { required: true, message: "请填写备注", trigger: "blur" },
          { min: 1, max: 200, message: "最多200个字符", trigger: "blur" },
        ],
      },
      // 绑定前置仓跟进人
      batchFollowerForm: {
        supply_ids: "",
        pre_storage_admin: "",
      },
      // 绑定商家运营跟进人
      batchBusinessOperatorFollowerForm: {
        supply_ids: "",
        follower_admin_id: "",
      },
      // 参与特价销售
      batchSpecialSaleForm: {
        supply_ids: "",
        special_sale: "",
      },
      supplyPermissionForm: {
        supply_ids: "",
        is_self: "",
        is_all_style: "",
        is_order_ability: "",
        remark: "",
      },
      actionInvitation: `${apiBaseURL}/erp/Supply/importInvitationRule`,
      optionsMap: {
        bankList: [],
      },
      // 选择鉴权类型弹窗
      isShowChooseAuthDialog: false,
      // 个人鉴权弹窗
      isShowPersonAuthDialog: false,
      // 鉴权弹窗
      isShowAuthDialog: false,
      // 初始绑定数据
      acctBindData: {
        supply_sub_acct_info: {},
      },
      // 绑定商家运营跟进人弹窗
      isShowBusinessOperatorDialog: false,
      formAcctType: {
        type: "",
      },
      formAcct: {
        bind_sub_acct_type: "",
        corporate_name: "",
        id_type: "1",
        id_number: "",
        payee_bank: "",
        payee_bank_account: "",
        bind_sub_acct_phone: "",
        payee_phone: "",
        company_name: "",
        credit_code: "",
        is_default: "2",
        check_code: "",
        order_no: "",
        auth_amt: "",
      },
      timer: null,
      count: constantMap.timeCount,
      activeStep: 0,
      loadingAcct: false,
      specialEventOrderWhitelistModalVisible: false,
      whiteListAction: `${apiBaseURL}/erp/Supply/importAutoStockPlan`,

      importBlackDayReportAction: `${apiBaseURL}/erp/Supply/importBlackDayReport`,

      loadingOnProgress: false,
      batchUpdatePerformanceMarketForm: {
        supply_id: "",
        attributable_market_id: "",
        attributable_market_sub_id: "",
      },
      performanceMarketOptions: [],
      performanceSubMarketOptions: [],
      batchUpdatePerformanceMarketFormRules: {
        supply_id: [
          { required: true, message: "请填写供应商", trigger: "blur" },
        ],
        attributable_market_id: [
          { required: true, message: "请选择业绩归属市场", trigger: "change" },
        ],
      },
      addressDialogVisible: false, // 地址弹框显示控制
      uploadUrl: `${apiBaseURL}/erp/Supply/importNoDataReturnData`,
      resultData: {
        success: [],
        error: [],
      },
      supplyControlModelVisible: false,
      showBindBuyer: false,
      showBindMarket: false,
    };
  },
  computed: {
    filteredForm() {
      const { form } = this;
      Object.keys(form).forEach((key) => {
        if (form[key] === undefined || form[key] === "" || form[key] === null) {
          delete form[key];
        }
      });
      return form;
    },
    acctTypeName() {
      const type = this.formAcct.payee_type || this.formAcct.bind_sub_acct_type;
      return this.constantMap.optionsAcctType.find(
        (item) => item.value === type
      )?.label;
    },
    idTypeName() {
      const { id_type: type } = this.formAcct;
      return this.constantMap.optionsIdType.find((item) => item.value === type)
        ?.label;
    },
    isHasSubAcct() {
      return this.acctBindData.is_sub_acct === constantMap.isHasSubAcct;
    },
  },
  created() {
    this.fetchData();
    // 读取本地存储的过滤项和表格列
    const localFilters = Local.get("supply-list-filters");
    const localTableColumns = Local.get("supply-list-table-columns");
    /* eslint no-param-reassign: ["error", { "props": false }] */
    this.filters.forEach((filter) => {
      if (!filter.show) {
        filter.show = localFilters[filter.prop];
      }
    });
    this.customFilters.forEach((column) => {
      if (localFilters[column.value]) {
        column.active = true;
      }
    });
    this.tableColumns.forEach((column) => {
      if (!column.show) {
        column.show = localTableColumns[column.prop];
      }
    });
    this.customTableColumns.forEach((column) => {
      if (localTableColumns[column.value]) {
        column.active = true;
      }
    });
    this.handleGetBankList();
    this.fetchOptionsData();
  },
  mounted() {
    const pgId = this.$route.query.pg_id;
    const { pgid } = this.$route.query;
    const { pgMemberId } = this.$route.query;
    if (pgId !== "undefined" && pgId !== null && pgId !== "" && pgId) {
      this.form.pg_id = pgId;
    }
    if (pgid !== "undefined" && pgid !== null && pgid !== "" && pgid) {
      this.form.pgid = pgid;
    }
    if (
      pgMemberId !== "undefined" &&
      pgMemberId !== null &&
      pgMemberId !== "" &&
      pgMemberId
    ) {
      this.form.pg_member_id = pgMemberId;
    }
  },
  methods: {
    handleDownloadTemplate() {
      this.$http
        .post("/erp/Supply/downNoDataReturnDataTemp", {
          download: 1,
        })
        .then((res) => {
          openDownloadWindow(res.data.data.file);
        });
    },
    changeAcctInfo(row) {
      this.supply_id = row.supply_id;
      console.log(this.supply_id);
      this.showChangeAcct = true;
    },
    handleGetBankList() {
      commonApi
        .getBankList()
        .then((res) => {
          this.optionsMap.bankList = res;
        })
        .catch(this.$noop);
    },
    handleAuthAccount(row) {
      this.supply_id = row.supply_id;
      supplyApi
        .getSupplySubAcctInfo({ supply_id: this.supply_id })
        .then((res) => {
          this.acctBindData = res;
          // 存在申请中的对公账户
          if (res.is_application_ing === constantMap.isApplying) {
            this.formAcct = res.supply_sub_acct_info;
            this.activeStep = 1;
            this.isShowAuthDialog = true;
          } else if (res.is_sub_acct === constantMap.isHasSubAcct) {
            if ([constantMap.businessBindType].includes(res.real_name_type)) {
              // 存在子账户且绑定类型为企业 或 子账户类型为对公账户
              this.formAcct = {
                ...this.formAcct,
                ...omitBy(res.supply_sub_acct_info, isNil),
                id_type:
                  res.supply_sub_acct_info.id_type === "0"
                    ? "1"
                    : res.supply_sub_acct_info.id_type,
                payee_phone: res.supply_sub_acct_info.bind_sub_acct_phone,
              };
              this.activeStep = 0;
              this.isShowAuthDialog = true;
            } else {
              this.formAcct = {
                ...this.formAcct,
                ...omitBy(res.supply_sub_acct_info, isNil),
                id_type:
                  res.supply_sub_acct_info.id_type === "0"
                    ? "1"
                    : res.supply_sub_acct_info.id_type,
                payee_phone: res.supply_sub_acct_info.bind_sub_acct_phone,
              };
              this.isShowChooseAuthDialog = true;
            }
          } else {
            this.activeStep = 0;
            this.isShowChooseAuthDialog = true;
          }
        })
        .catch(this.$noop);
    },
    handleAuthTypeDialogClose() {
      this.$refs.formAcctType.resetFields();
      this.formAcctType = this.$options.data.call(this).formAcctType;
    },
    handleConfirmAuthType() {
      this.$refs.formAcctType.validate((valid) => {
        if (valid) {
          const { type } = this.formAcctType;
          this.formAcct.bind_sub_acct_type = type;
          if (type === constantMap.businessAcct) {
            if (
              this.isHasSubAcct &&
              this.acctBindData.real_name_type === constantMap.personalBindType
            ) {
              this.$message.info(
                "已绑定个人银行卡，不可绑定企业对公账户，请重新选择"
              );
            } else if (
              this.isHasSubAcct &&
              this.acctBindData.real_name_type ===
                constantMap.individualBindType
            ) {
              this.$message.info(
                "已绑定个体工商户对公账户，不可绑定企业对公账户，请重新选择"
              );
            } else {
              this.isShowAuthDialog = true;
              this.isShowChooseAuthDialog = false;
            }
          } else if (type === constantMap.individualAcct) {
            // 个体工商户
            if (
              this.isHasSubAcct &&
              this.acctBindData.supply_sub_acct_info.id_type !==
                constantMap.idCard
            ) {
              // 非身份证用户
              this.$message.info(
                "子账户使用非身份证类型注册的，不支持绑定个体工商户对公账户，请重新选择"
              );
              return;
            }
            this.isShowAuthDialog = true;
            this.isShowChooseAuthDialog = false;
          } else {
            this.isShowPersonAuthDialog = true;
            this.isShowChooseAuthDialog = false;
          }
        }
      });
    },
    handleAuthDialogClose() {
      this.$refs.formAcct.resetFields();
      this.formAcct = this.$options.data.call(this).formAcct;
      this.acctBindData = {
        supply_sub_acct_info: {},
      };
      this.activeStep = 0;
      clearInterval(this.timer);
      this.timer = null;
      this.count = constantMap.timeCount;
      this.loadingAcct = false;
    },
    handleSendSms() {
      this.$refs.formAcct.clearValidate();
      const promises = [
        "corporate_name",
        "id_number",
        "payee_phone",
        "payee_bank",
        "payee_bank_account",
      ].map((key) => {
        return new Promise((resolve, reject) => {
          this.$refs.formAcct.validateField(key, (error) => {
            if (error) {
              reject(error);
            } else {
              resolve();
            }
          });
        });
      });
      Promise.all(promises)
        .then(() => {
          supplyApi
            .bindSupplySubAcct({
              ...this.formAcct,
              supply_id: this.supply_id,
            })
            .then(() => {
              this.timeTick();
              this.$message.success("发送成功");
            })
            .catch(this.$noop);
        })
        .catch(this.$noop);
    },
    handleResendSms() {
      supplyApi
        .retryCode({
          ...this.formAcct,
          supply_id: this.supply_id,
        })
        .then(() => {
          this.timeTick();
          this.$message.success("发送成功");
        })
        .catch(this.$noop);
    },
    timeTick() {
      if (!this.timer) {
        this.count = constantMap.timeCount;
        this.timer = setInterval(() => {
          if (this.count > 1 && this.count <= constantMap.timeCount) {
            this.count -= 1;
          } else {
            clearInterval(this.timer);
            this.timer = null;
            this.count = constantMap.timeCount;
          }
        }, 1000);
      }
    },
    handleAcctApplyCancel() {
      this.$confirm("请确认是否取消当前绑卡申请？", "取消绑卡", {})
        .then(() => {
          const id = this.formAcct.application_id;
          console.log("------handleAcctApplyCancel id ", id);
          supplyApi
            .cancelApplication({ application_id: id })
            .then(() => {
              this.$message.success("取消绑卡成功");
              this.isShowAuthDialog = false;
            })
            .catch(this.$noop);
        })
        .catch(this.$noop);
    },
    handleConfirmAuthAcctApply() {
      if (this.loadingAcct) {
        return;
      }
      this.$refs.formAcct.validate((valid) => {
        if (valid) {
          this.loadingAcct = true;
          supplyApi
            .bindSupplySubAcct({
              ...this.formAcct,
              supply_id: this.supply_id,
            })
            .then(() => {
              this.$message.success("申请成功");
              this.handleAuthAccount({ supply_id: this.supply_id });
            })
            .catch(this.$noop)
            .finally(() => {
              this.loadingAcct = false;
            });
        }
      });
    },
    handleConfirmAuthAcct() {
      if (this.loadingAcct) {
        return;
      }
      this.$refs.formAcct.validate((valid) => {
        if (valid) {
          this.loadingAcct = true;
          supplyApi
            .submitCheck(
              {
                ...this.formAcct,
                bind_sub_acct_type:
                  this.formAcct.payee_type || this.formAcct.bind_sub_acct_type,
                supply_id: this.supply_id,
              },
              { useDataField: false }
            )
            .then((res) => {
              this.$message.success(res.data.msg);
              this.isShowPersonAuthDialog = false;
              this.isShowAuthDialog = false;
              this.fetchData();
            })
            .catch(this.$noop)
            .finally(() => {
              this.loadingAcct = false;
            });
        }
      });
    },
    handleSizeChange(e) {
      this.form.page_size = e;
      this.fetchData();
    },

    handleBatchChangeStatusClose() {
      this.isShowBatchChangeStatusDialog = false;
      this.batchUpdateSupplyForm =
        this.$options.data.call(this).batchUpdateSupplyForm;
    },
    handleBatchChangeStatus() {
      this.$refs.batchUpdateSupplyFormRef.validate((valid) => {
        if (valid) {
          const { status } = this.batchUpdateSupplyForm;
          const params = {
            remark: this.batchUpdateSupplyForm.remark,
            status,
            supply_ids: this.batchUpdateSupplyForm.supply_ids.split("\n"),
          };

          const text = constantMap.optionSupplyStatus.find(
            (item) => item.value === status
          ).confirmText;
          this.$confirm(text, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              batchUpdateSupply(params)
                .then(() => {
                  this.isShowBatchChangeStatusDialog = false;
                  this.batchUpdateSupplyForm =
                    this.$options.data.call(this).batchUpdateSupplyForm;
                })
                .catch((err) => {
                  if (err.code === 400) {
                    const { file } = err.data;
                    this.isShowBatchChangeStatusDialog = false;
                    this.batchUpdateSupplyForm =
                      this.$options.data.call(this).batchUpdateSupplyForm;
                    if (file) {
                      window.open(apiBaseURL + file);
                    }
                  }
                });
            })
            .catch(() => {
              console.log("关闭");
            });
        }
      });
    },
    showImportSupplyFile() {
      this.importSupplyFileVisible = true;
    },
    handleDialogButtonClose() {
      this.supply_ids = [];
      this.isShowBatchDialog = false;
      this.fetchData();
    },
    closeBox(e) {
      // this.supply_ids = [];
      this.supply_id = 0;
      //   this.$refs.multipleTable.clearSelection();
      this.showBind = false;
      this.showChangeAcct = false;
      if (e && e.visible) {
        this[e.visible] = false;
      }
    },
    closeDgBox(e) {
      // this.supply_ids = [];
      //   this.$refs.multipleTable.clearSelection();
      this.showDgBind = false;
      if (e) {
        // this.fetchData();
      }
    },
    closeImportSupplyFile(e) {
      this.importSupplyFileVisible = false;
      if (e) {
        this.fetchData();
      }
    },
    setChild(value) {
      if (this.form.father_market_id.length === 0) {
        this.filters.find((item2) => item2.prop === "market_id").options =
          this.marketOptions[0].children;
      } else {
        this.form.market_id = [];
        let newOptions = [];
        Object.keys(this.marketOptions).forEach((item) => {
          value.forEach((event) => {
            if (+event === +this.marketOptions[item].key) {
              newOptions = [
                ...newOptions,
                ...this.marketOptions[item].children,
              ];
            }
          });
        });
        this.filters.find((item2) => item2.prop === "market_id").options =
          newOptions;
      }
    },
    // 选择代采员
    handleChangeMember(value) {
      this.$set(this.form, "pg_member_id", value);
      this.$forceUpdate();
    },
    // 选择次品员
    handleChangeDefectiveGroupMember(value) {
      this.$set(this.form, "dg_member_id", value);
      this.$forceUpdate();
    },
    addColor() {
      // if (columnIndex === 15) {
      //     return 'blue-cell';
      // }
    },
    output() {
      this.$http
        .post("/erp/Supply/exportSupply", { ...this.filteredForm, is_excel: 1 })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        console.log("re1111s: ", res);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.loading = false;
        }
      });
    },
    fetchOptionsData() {
      getOptionsForSupplyList({}).then(async (res) => {
        const marketList = await getGetAttributableMarketList();
        console.log("---marketList", marketList);
        const formatMarketList = marketList.map((item) => ({
          label: item.attributable_market_name,
          value: item.attributable_market_id,
          subList: item.sub_list,
        }));
        this.loading = false;
        this.resData = res;
        // 下拉选择选项

        this.filters.forEach((filter) => {
          if (filter.optionsName) {
            filter.options = [
              ...filter.options,
              ...this.resData[filter.optionsName],
            ];
          }
          if (filter.prop === "market_id") {
            filter.options = this.resData.market[0].children;
          }
          if (filter.prop === "attributable_market_id") {
            filter.options = formatMarketList;
          }
        });

        this.marketOptions = this.resData.market;

        this.performanceMarketOptions = formatMarketList;

        // 次品组
        this.defectiveGroupOption = this.resData.defectiveGroupOption;
      });
    },
    fetchAll() {
      this.fetchData(true);
      this.fetchOptionsData();
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      console.log("🚀 : handleSelectionChange : val", val);
      this.selectionList = val;
      const temp = val;
      temp.forEach((element) => {
        this.supply_ids.push(element.supply_id);
      });
      this.supply_ids = val.map((element) => {
        return element.supply_id;
      });
      // const multipleSelection = [];

      // Object.keys(val).forEach((key) => {
      //   multipleSelection[key] = {
      //     id: val[key].id,
      //   };
      // });
      // this.form.multipleSelection = JSON.stringify(multipleSelection);
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    reset() {
      this.form = {
        page_size: 10,
        page: 1,
      };
    },
    trim(str, isGlobal) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (isGlobal.toLowerCase() === "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    openSelectPg(row) {
      this.form.supply_id = row.supply_id;
      this.dialogFormVisible = true;
    },
    closeAcctInfo(row) {
      this.$confirm("确认销户?", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/supply/closeAcctInfo", {
              supply_id: row.supply_id,
            })
            .then((result) => {
              if (result.data.code !== 200) {
                this.$message.e(result.data.msg);
                return;
              }
              this.$message.success(result.data.msg);
              this.fetchData(true);
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    setPg() {
      if (!this.form.set_pgid) {
        this.$alert("请选择要绑定的代采组", "操作错误");
        return;
      }
      this.dialogFormVisible = false;
      this.loading = true;
      this.$http.post("/erp/supply/band", this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message({
            type: res.data.data.msg_type,
            message: res.data.data.msg,
          });
          this.fetchData(true);
        }
      });
    },
    addSupply() {
      this.$router.push("/home/supply/addsupply");
    },
    updateSupply(row) {
      this.$router.push(`/home/supply/updatesupply/${row.supply_id}`);
    },
    showSupply(row) {
      this.$router.push(`/home/supply/showsupply/${row.supply_id}`);
    },
    profile(row) {
      this.$router.push(`/home/supply/profile/${row.supply_id}`);
    },
    supplyLog(row) {
      this.cur_id = row.supply_id;
      this.$http
        .get(`/erp/supply/getLog/supply_id/${row.supply_id}`)
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.logData = res.data.data;
            this.logVisible = true;
          }
        });
    },
    // 切换页码
    handleCurrentChange2(val) {
      this.form.page = val;
      // this.tableLoading = true;
      this.$http
        .get(`/erp/supply/getLog/supply_id/${this.cur_id}/page/${val}`)
        .then((res) => {
          setTimeout(() => {
            this.tableLoading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.logData = res.data.data;
          }
        });
    },
    /* 跳转先货后款账单 */
    supplySettle(row) {
      this.$router.push(`/home/supplybill/${row.supply_id}`);
    },

    // 导入更新按计划点货的商家
    // savePlanSupplyIdSuccess(data) {
    //   if (data.code !== 200) {
    //     this.$message.e(data.msg);
    //     return;
    //   }
    //   if (data.data.file) {
    //     window.open(apiBaseURL + data.data.file);
    //   } else {
    //     this.$message.success("导入成功");
    //   }
    // },
    // 导出按计划点货的商家
    // exportPlanSupplyId() {
    //   this.$post("/erp/supply/exportExcelToPlanSupply").then((rs) => {
    //     window.open(apiBaseURL + rs.file);
    //   });
    // },
    handleExportFulfill() {
      if (!this.selectionList.length) {
        this.$message.info("请勾选需要导出的商家");
        return;
      }
      const supplyIdList = this.selectionList.map((item) => item.supply_id);
      downloadSupplyFulfill({ supply_id: supplyIdList })
        .then((res) => {
          const { code, data, msg } = res.data;
          if (String(code) === "200") {
            window.open(apiBaseURL + data.file);
          } else {
            this.$message.error(msg);
          }
        })
        .catch(() => {});
    },
    // 导出商家合同信息
    handleExportContract() {
      exportSupplyContract({
        supply_id: this.filteredForm.supply_id,
        is_excel: "2",
      })
        .then((data) => {
          const { file } = data;
          window.open(apiBaseURL + file);
        })
        .catch(() => {});
    },
    // 选择代采组
    getMemberOption(e) {
      if (e.length === 0) {
        this.filters.find((item) => item.prop === "pg_member_id").options =
          this.resData.memberOption;
      } else {
        this.memberOption = [];
        this.form.pg_member_id = [];
        this.loading = true;
        this.$http.post("/erp/Common/getPgMember", { pgid: e }).then((res) => {
          this.loading = false;
          if (res.data.data.length < 1) {
            this.$message.info("请先绑定代采员至该代采组下");
            return;
          }
          this.filters.find((item) => item.prop === "pg_member_id").options =
            res.data.data;
        });
      }
    },
    // 选择次品组
    getDefectiveGroupMember(val) {
      if (val.length === 0) {
        this.filters.find((item) => item.prop === "dg_member_id").options =
          this.defectiveGroupOption;
      } else {
        this.form.dg_member_id = [];
        this.defectiveGroupMemberOption = [];
        this.$http
          .post("/erp/Defective/getGroupMember", {
            dgid: val,
          })
          .then((res) => {
            if (res.data.code === 200) {
              this.filters.find(
                (item) => item.prop === "dg_member_id"
              ).options = res.data.data.member;
            }
          });
      }
    },
    // 下拉选择 change 事件
    handleEvent(event, value) {
      console.log(event, value);
      if (event) {
        this[event](value);
      }
    },
    // 打开自定义选项框
    handleSetCustomFilter() {
      this.customFilterVisible = true;
    },
    // 选择搜索项
    handleToggleFilter(item) {
      item.active = !item.active;
      this.filters.find((filter) => filter.prop === item.value).show =
        item.active;
      // 本地存储过滤项
      const localFilters = Local.get("supply-list-filters");
      localFilters[item.value] = item.active;
      Local.set("supply-list-filters", localFilters);
      // 取消选中，删除搜索项
      if (!item.active) {
        delete this.form[item.value];
      }
    },
    // 打开设置表头
    handleSetTableColumn() {
      this.customTableColumnVisible = true;
    },
    // 选择表头项
    handleToggleTableColumn(item) {
      item.active = !item.active;
      this.tableColumns.find((column) => column.prop === item.value).show =
        item.active;
      // 本地存储表格列
      const localTableColumns = Local.get("supply-list-table-columns");
      localTableColumns[item.value] = item.active;
      Local.set("supply-list-table-columns", localTableColumns);
      // fix 动态增加列之后 fixed 列样式错位
      this.$nextTick(() => {
        this.$refs.multipleTable.doLayout();
      });
    },
    // 绑定前置仓跟进人
    handleBindFollower() {
      // 获取跟进人列表
      this.getFollowerOptions();
      this.isShowBatchBindFollowerDialog = true;
    },
    // 绑定商家运营跟进人
    handleBindBusinessOperatorFollower() {
      this.getBusinessOperatorFollowerOptions();
      this.isShowBusinessOperatorDialog = true;
    },
    // 关闭批量绑定前置仓跟进人
    handleBatchBindFollowerClose() {
      this.isShowBatchBindFollowerDialog = false;
      this.batchFollowerForm = this.$options.data.call(this).batchFollowerForm;
    },
    // 关闭批量商家运营跟进人
    handleBatchBindBusinessOperatorFollowerClose() {
      this.isShowBusinessOperatorDialog = false;
      this.batchBusinessOperatorFollowerForm =
        this.$options.data.call(this).batchBusinessOperatorFollowerForm;
    },
    // 关闭批量修改能否参与特价销售
    handleBatchSpecialSaleClose() {
      this.isShowSpecialSaleDialog = false;
      this.batchSpecialSaleForm =
        this.$options.data.call(this).batchSpecialSaleForm;
    },
    handleBatchSupplyPermissionClose() {
      this.isShowSupplyPermissionDialog = false;
      this.supplyPermissionForm =
        this.$options.data.call(this).supplyPermissionForm;
    },
    // 获取跟进人列表
    getFollowerOptions() {
      getAllEnableAdmin({}).then((res) => {
        this.followerList = res.enable_admin_list;
      });
    },
    // 获取商家运营跟进人列表
    getBusinessOperatorFollowerOptions() {
      postGetAllEnableAdmin({}).then((res) => {
        this.businessOperatorFollowerList = res.enable_admin_list;
      });
    },

    // 提交跟进人绑定申请
    handleBatchBindFollower() {
      const { supply_ids: supplyIds, pre_storage_admin: preStorageAdmin } =
        this.batchFollowerForm;
      // 校验是否有商家id
      if (supplyIds === "") {
        this.$message({
          showClose: true,
          message: "请输入商家ids~",
          type: "error",
        });
        return;
      }

      const params = {
        supply_ids: supplyIds.trim().split("\n"),
        pre_storage_admin: preStorageAdmin === "" ? 0 : preStorageAdmin,
      };

      batchUpdateSupplyPreStorageAdmin(params)
        .then((res) => {
          this.$message.success(res);
          this.isShowBatchBindFollowerDialog = false;
        })
        .catch((error) => {
          const { file } = error.data;
          window.open(apiBaseURL + file);
        });
    },
    // 提交商家运营跟进人绑定申请
    handleBatchBindBusinessOperatorFollower() {
      const { supply_ids: supplyIds, follower_admin_id: followerAdminId } =
        this.batchBusinessOperatorFollowerForm;
      // 校验是否有商家id
      if (supplyIds === "" || followerAdminId === "") {
        this.$message({
          showClose: true,
          message: "请录入商家与跟进人~",
          type: "error",
        });
        return;
      }

      const params = {
        supply_ids: supplyIds.trim().split("\n"),
        follower_admin_id: followerAdminId === "" ? 0 : followerAdminId,
      };

      postBatchUpdateFollowerAdmin(params)
        .then(() => {
          this.$message.success("成功绑定商家运营跟进人");
          this.isShowBusinessOperatorDialog = false;
        })
        .catch((error) => {
          // Check if error data contains a file before attempting to download
          if (error && error.data && error.data.file) {
            window.open(apiBaseURL + error.data.file);
          } else {
            this.$message.error("提交失败，请稍后重试");
          }
        });
    },
    // 提交修改「能否参与特价销售」
    handleBatchSpecialSale() {
      const trimmedSupplyIds = this.batchSpecialSaleForm.supply_ids.trim();
      const supplyIdsArray = trimmedSupplyIds.split(/\r?\n/);
      const {
        special_sale: specialSale,
        is_special_treatment: isSpecialTreatment,
      } = this.batchSpecialSaleForm;
      if (supplyIdsArray.length > 1000) {
        this.$message({
          showClose: true,
          message: "商家ID超过1000个，提交失败",
          type: "error",
        });
        return;
      }
      if (
        trimmedSupplyIds === "" ||
        specialSale === "" ||
        isSpecialTreatment === ""
      ) {
        this.$message({
          showClose: true,
          message: "缺少必要参数，提交失败",
          type: "error",
        });
        return;
      }
      const params = {
        supply_ids: supplyIdsArray,
        special_sale: specialSale,
        is_special_treatment: isSpecialTreatment,
      };
      postBatchUpdateSpecialSaleStatus(params)
        .then(() => {
          this.$message.success("成功修改「能否参与特价销售」");
          this.isShowSpecialSaleDialog = false;
        })
        .catch((error) => {
          if (error && error.data && error.data.file) {
            window.open(apiBaseURL + error.data.file);
          } else {
            this.$message.error("提交失败，请稍后重试");
          }
        });
    },
    // 批量修改商家权限
    handleBatchSupplyPermission() {
      this.$refs.supplyPermissionFormRef.validate((valid) => {
        if (valid) {
          const trimmedSupplyIds = this.supplyPermissionForm.supply_ids.trim();
          const supplyIdsArray = trimmedSupplyIds.split(/\D+/).filter(Boolean);
          if (supplyIdsArray.length > 1000) {
            this.$message({
              showClose: true,
              message: "商家ID不超过1000个",
              type: "info",
            });
            return;
          }
          const params = {
            ...this.supplyPermissionForm,
            supply_ids: supplyIdsArray.join(","),
          };
          postBatchEditLimitsAuthority(params)
            .then((res) => {
              this.isShowSupplyPermissionDialog = false;
              this.resultData = res;
              this.isShowSupplyPermissionResultDialog = true;
            })
            .catch(this.$noop);
        }
      });
    },
    // 显示商家鉴权白名单操作弹框
    handleShowAuthWhite() {
      console.log("12312", this.$refs.authWhiteRef);
      this.$refs.authWhiteRef.showDialog();
    },
    // 显示承诺库存黑名单操作弹框
    handleCommittedSpotBlacklist() {
      this.$refs.committedSpotBlacklistDialogRef.showDialog();
    },
    // 显示特殊货期黑名单操作弹框
    handleShowSpecialBlacklist() {
      this.$refs.specialBlacklistDialogRef.showDialog();
    },
    handleExportInvitationRule() {
      invitationPoolApi
        .exportInvitationRule()
        .then(openDownloadWindow)
        .catch(this.$noop);
    },
    handleImportSuccess(res) {
      if (res.code !== 200) {
        this.$message.error(res.msg);
        openDownloadWindow(res.data);
      } else {
        this.$message.success("成功导入！");
      }
      this.isShowInvitationPoolDialog = false;
    },
    handleInvitationDialogClose() {
      this.$refs.invitationUpload.clearFiles();
    },
    importWhiteList(data) {
      this.loadingOnProgress = false;
      if (data.code !== 200) {
        this.$message.e(data.msg);
        return;
      }
      if (data.data.file) {
        window.open(apiBaseURL + data.data.file);
      } else {
        this.$message.success("导入成功");
      }
    },
    exportWhiteList() {
      getExportAutoStockPlan().then((res) => {
        window.open(apiBaseURL + res.file);
      });
    },

    onExportBlackDayReport() {
      postExportBlackDayReport().then((res) => {
        window.open(apiBaseURL + res.file);
      });
    },

    showWhiteListOperationModal() {
      this.specialEventOrderWhitelistModalVisible = true;
    },
    showLoadingOnProgress() {
      this.loadingOnProgress = true;
    },
    // 下载查看日志备注文件
    handleDownloadFile(file) {
      window.open(file);
    },
    handleBatchPerformanceMarketClose() {
      this.isShowPerformanceMarketDialog = false;
      this.batchUpdatePerformanceMarketForm =
        this.$options.data.call(this).batchUpdatePerformanceMarketForm;
    },
    handleBatchPerformanceMarket() {
      this.$refs.batchUpdatePerformanceMarketFormRef.validate((valid) => {
        if (valid) {
          postBatchBindAttributableMarket({
            ...this.batchUpdatePerformanceMarketForm,
            supply_id: this.batchUpdatePerformanceMarketForm.supply_id
              .split(/\D+/)
              .filter(Boolean)
              .join(","),
          })
            .then(() => {
              this.isShowPerformanceMarketDialog = false;
              this.$message.success("操作成功");
              this.fetchData();
            })
            .catch(this.$noop);
        }
      });
    },
    handleSetAttributableSubMarket(attributableMarketId) {
      this.batchUpdatePerformanceMarketForm.attributable_market_sub_id = "";
      const selectedMainMarket = this.performanceMarketOptions.find(
        (option) => option.value === attributableMarketId
      );
      if (selectedMainMarket) {
        this.performanceSubMarketOptions = selectedMainMarket.subList;
      } else {
        this.performanceSubMarketOptions = [];
      }
    },
    // 显示地址弹框
    handleShowAddressDialog() {
      this.addressDialogVisible = true;
    },
    // 上传前校验
    beforeUpload(file) {
      // 这里可以添加文件类型、大小等校验
      const suffixList = [".csv", ".xlsx", ".xls"];
      const isExcel = suffixList.some((suffix) => file.name.endsWith(suffix));
      if (!isExcel) {
        this.$message.info(
          `文件类型错误，请重新选择，仅支持${suffixList.join(",")}格式`
        );
        return false;
      }
      return true;
    },
    // 上传成功回调
    handleUploadSuccess(res) {
      if (res.code === 200) {
        this.$message.success("上传成功");
      } else if (res.data.file) {
        openDownloadWindow(res.data.file);
      } else {
        this.$message.error(res.msg);
      }
    },
    // 确认修改地址
    handleConfirmAddress() {
      this.addressDialogVisible = false;
      // 这里可以添加确认后的操作
    },
    handleCloseReturnAddressDialog() {
      this.isShowReturnAddressDialog = false;
      this.fetchData(); // 刷新数据
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.form-filter-item {
  display: inline-block;
}

.custom-list {
  overflow: hidden;
  border-left: 1px solid #dcdfe6;
  border-top: 1px solid #dcdfe6;
}

.custom-item {
  float: left;
  border-right: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  padding: 0 10px;
  width: 168px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

.custom-item:hover {
  color: #fff;
  background: rgba(133, 206, 97, 50%);
}

.custom-item--active {
  color: #fff;
  background: #85ce61;
}

.filter-box-btns {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.address-item {
  margin-bottom: 20px;

  .label {
    font-weight: bold;
    margin-bottom: 10px;
  }

  .desc {
    color: #999;
    font-size: 12px;
    margin-top: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/supply/SupplyList.vue